<template>
  <b-modal
    id="qr-code-modal"
    :title="$t('contract.qr_code')"
    ok-only
    :ok-title="$t('generals.close')"
    size="lg"
  >
    <b-img
      class="w-100"
      :src="photo"
    />
  </b-modal>
</template>

<script>
import { BModal, BImg } from 'bootstrap-vue'

export default {
  components: {
    BModal,
    BImg,
  },
  props: {
    photo: {
      type: String,
      required: true,
      default: 'https://upload.wikimedia.org/wikipedia/commons/thumb/d/d0/QR_code_for_mobile_English_Wikipedia.svg/1200px-QR_code_for_mobile_English_Wikipedia.svg.png',
    },
  },
}
</script>

<style>

</style>
